import axios from './axios';

export const getBoards = () => {
  return axios.get('/webapi/boards/v2/boards/frontend/board/userCanView');
};
